import React from 'react';
import './TheTeacherDashboard.css';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';

function getStatusMeta(status) {
  const normalized = (status || '').toLowerCase();

  if (normalized === 'ready') {
    return { className: 'latest-badge latest-badge--ready', Icon: CheckCircleOutlineIcon };
  }
  if (normalized === 'initial') {
    return { className: 'latest-badge latest-badge--initial', Icon: HourglassEmptyIcon };
  }
  if (normalized === 'review' || normalized === 'inreview') {
    return { className: 'latest-badge latest-badge--review', Icon: RateReviewOutlinedIcon };
  }
  if (normalized === 'published') {
    return { className: 'latest-badge latest-badge--published', Icon: PublicOutlinedIcon };
  }

  return { className: 'latest-badge latest-badge--default', Icon: CheckCircleOutlineIcon };
}

export default function LatestAssessments({ managedAssessments, myAssessmentsLoading }) {
  return (
    <div className="latest-assessments">
      <div className="latest-header">
        <h6 className="latest-title">Latest Papers</h6>
        <span className="dots-icon">⋯</span>
      </div>

      <div className="latest-content">
        <div className="latest-list">
          {!myAssessmentsLoading && managedAssessments && managedAssessments.length > 0 ? (
            managedAssessments.map((item, index) => {
              const date = new Date(item?.created_at);
              const formattedDate = date.toISOString().split('T')[0];
              const statusMeta = getStatusMeta(item.assessment_state);
              const StatusIcon = statusMeta.Icon;

              return (
                <div className="latest-item" key={index}>
                  <div className="latest-item-main">
                    <span className="latest-doc" aria-hidden="true">
                      <ArticleOutlinedIcon />
                    </span>
                    <div className="latest-info">
                      <div className="latest-name">{item.title || "N/A"}</div>
                      <div className="latest-date">
                        <CalendarMonthRoundedIcon className="latest-date-icon" />
                        {formattedDate}
                      </div>
                    </div>
                  </div>
                  <span className={statusMeta.className}>
                    <StatusIcon className="latest-status-icon" />
                    {item.assessment_state || "N/A"}
                  </span>
                </div>
              );
            })
          ) : (
            <div className="latest-empty">
              {myAssessmentsLoading ? "Loading..." : "No Assessments found"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
